import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate instead of useHistory
import Cookies from 'js-cookie';

import Layout from '../components/Layout/Layout.jsx'
import "../styles/donate.css"

const Donate = () => {
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [catageryFood, setCatageryFood] = useState<string | null>("cooked-food");
  const [userId, setUserId] = useState<string | null>(null);


  const navigate =  useNavigate();

useEffect(() => {
  const token = Cookies.get('token'); // replace 'token' with your actual cookie key
  const userId = Cookies.get('user'); // replace 'user' with your actual cookie key
  if (userId) {
    setUserId(userId);
  }

  if (!token) {
    navigate('/login'); // Redirect to login if token not found
  }
}, [navigate]);






  // Handle image input
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;
    if (file) {
      setImageFile(file);
      setImageUrl(URL.createObjectURL(file));
    }
  };

  // Submit form with FormData including the image file
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    if (imageFile) {
      formData.append('image', imageFile); // Add image to form data
    }
    if(userId) {
      formData.append('userId', userId);
    }

    try {
      const apiUrl = process.env.REACT_APP_MODE === 'development'
        ? 'http://localhost:8000/api/v1/user/donation'
        : `${process.env.REACT_APP_API_URL}/user/donation`;

      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData, // send multipart/form-data
      });

      const result = await response.json();

      if (response.ok) {
        alert('Donation submitted successfully!');
        form.reset();
        setImageFile(null);
        setImageUrl(null);
      } else {
        alert(`Failed to submit: ${result.message}`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  return (
    <Layout title="Lastbites: Food Donate">
      <main className="donate">
        <div className="DonateContainer">
          <div className="regformf">
            <form method="post" className='Donateform' onSubmit={handleSubmit} encType="multipart/form-data">
              <p className="logo">Food <b style={{ color: '#06C167' }}>Donate</b></p>

              <div className="input">
                <label htmlFor="foodname">Name (Which you want to donate):</label>
                <input type="text" id="foodname" name="foodname" required />
              </div>

              {/* Image Upload */}
              <div className="image-upload">
                <h2>Upload Image of (Which you want to donate)</h2>
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={handleFileChange} 
                  required
                />
                {imageUrl && (
                  <div>
                    <h3>Preview:</h3>
                    <img src={imageUrl} alt="Preview" style={{ width: '300px', height: 'auto' }} />
                  </div>
                )}
                {imageFile && <p>Uploaded file: {imageFile.name}</p>}
              </div>

              <br />

              {/* Meal type */}
              <div className="radio">
                <label htmlFor="meal">Meal type:</label>
                <span className='mealRadioSpan'>
                  <span className='mealRadioSpan1'>
                    <input type="radio" name="meal" id="veg" value="veg" required />
                    <label htmlFor="veg">Veg</label>
                  </span>
                  <span className='mealRadioSpan1'>
                    <input type="radio" name="meal" id="Non-veg" value="Non-veg" />
                    <label htmlFor="Non-veg">Non-veg</label>
                  </span>
                </span>
              </div>

              <br />

              {/* Food category */}
              <div className="input">
                <label>Select the Category:</label>
                <div className="image-radio-group">
                  <input type="radio" id="cooked-food" name="image-choice"  value="cooked-food" onChange={() => setCatageryFood("cooked-food")} defaultChecked/>
                  <label htmlFor="cooked-food">
                    <img src="/Resources/cooked-food.png" alt="cooked-food" />
                  </label>
                  <input type="radio" id="raw-food" name="image-choice" value="raw-food" onChange={() => setCatageryFood("raw-food")}  />
                  <label htmlFor="raw-food">
                    <img src="/Resources/raw-food.png" alt="raw-food" />
                  </label>
                  <input type="radio" id="packed-food" name="image-choice" value="packed-food" onChange={() => setCatageryFood("packed-food")}    />
                  <label htmlFor="packed-food">
                    <img src="/Resources/packed-food.png" alt="packed-food" />
                  </label>
                </div>
              </div>

              {/* Quantity */}
              <div className="input">
                <label htmlFor="quantity">Quantity (in number of person / kg / Pieces / Packets):</label>
                <input type="text" id="quantity" name="quantity" required />
              </div>

              {/* Cooking date/time */}
              {catageryFood === "cooked-food" && (
                <div className="input">
                <label htmlFor="dateOfCooking">Date and Time of Cooking:</label>
                <input type="datetime-local" id="dateOfCooking" name="dateOfCooking" required />
              </div>
              )}
              {catageryFood === "raw-food" && (
                <div className="input">
                  <label htmlFor="expectedExpiryDate">Expected Expiry Date:</label>
                  <input type="date" id="expectedExpiryDate" name="expiryDate" required />
                </div>
              )}

              {catageryFood === "packed-food" && (
                <div className="input">
                  <label htmlFor="expiryDate">Expiry Date:</label>
                  <input type="date" id="expiryDate" name="expiryDate" required />
                </div>
              )}
       

              {/* Date and Time of Cooking */}
              
            
              {/* <div className="input">
                <label htmlFor="dateOfCooking">Date and Time of Cooking:</label>
                <input type="datetime-local" id="dateOfCooking" name="dateOfCooking" required />
              </div> */}

              {/* Contact Details */}
              <b><p style={{ textAlign: 'center' }}>Contact Details</p></b>
              <div className="input">
                <label htmlFor="name">Name:</label>
                <input type="text" id="name" name="name" required />
              </div>

              <div className="input">
                <label htmlFor="phoneno">Phone No:</label>
                <input type="text" id="phoneno" name="phoneno" maxLength={10} pattern="[0-9]{10}" required />
              </div>

              <div className="input">
                <label htmlFor="district">District:</label>
                <select id="district" name="district" style={{ padding: 10 }} required>
  <option value="">Select District</option>
  <option value="agra">Agra</option>
  <option value="aligarh">Aligarh</option>
  <option value="ambedkar_nagar">Ambedkar Nagar</option>
  <option value="ameethi">Amethi</option>
  <option value="auraiya">Auraiya</option>
  <option value="ayodhya">Ayodhya</option>
  <option value="azamgarh">Azamgarh</option>
  <option value="bahraich">Bahraich</option>
  <option value="ballia">Ballia</option>
  <option value="balrampur">Balrampur</option>
  <option value="banda">Banda</option>
  <option value="barabanki">Barabanki</option>
  <option value="bareilly">Bareilly</option>
  <option value="basti">Basti</option>
  <option value="bhadohi">Bhadohi</option>
  <option value="bijnor">Bijnor</option>
  <option value="bulandshahr">Bulandshahr</option>
  <option value="chandauli">Chandauli</option>
  <option value="chitrakoot">Chitrakoot</option>
  <option value="deoria">Deoria</option>
  <option value="etah">Etah</option>
  <option value="etawah">Etawah</option>
  <option value="faizabad">Faizabad</option>
  <option value="farrukhabad">Farrukhabad</option>
  <option value="fatehpur">Fatehpur</option>
  <option value="ghaziabad">Ghaziabad</option>
  <option value="gharakhpur">Gorakhpur</option>
  <option value="guptanagar">Gautam Budh Nagar</option>
  <option value="hamirpur">Hamirpur</option>
  <option value="hathras">Hathras</option>
  <option value="jalaun">Jalaun</option>
  <option value="jammu">Jammu</option>
  <option value="jaunpur">Jaunpur</option>
  <option value="jodhpur">Jodhpur</option>
  <option value="kanpur">Kanpur</option>
  <option value="kaushambi">Kaushambi</option>
  <option value="kushinagar">Kushinagar</option>
  <option value="laheriasarai">Laheria Sarai</option>
  <option value="lakhimpur">Lakhimpur Kheri</option>
  <option value="lucknow">Lucknow</option>
  <option value="mathura">Mathura</option>
  <option value="meerut">Meerut</option>
  <option value="mau">Mau</option>
  <option value="maurawan">Maurawan</option>
  <option value="mohammadabad">Mohammadabad</option>
  <option value="mirzapur">Mirzapur</option>
  <option value="moradabad">Moradabad</option>
  <option value="muzaffarnagar">Muzaffarnagar</option>
  <option value="pratapgarh">Pratapgarh</option>
  <option value="pilibhit">Pilibhit</option>
  <option value="raebareli">Raebareli</option>
  <option value="rampur">Rampur</option>
  <option value="shahjahanpur">Shahjahanpur</option>
  <option value="santkabirnagar">Sant Kabir Nagar</option>
  <option value="saharanpur">Saharanpur</option>
  <option value="sant_ravidas_nagar">Sant Ravidas Nagar</option>
  <option value="sonbhadra">Sonbhadra</option>
  <option value="sultanpur">Sultanpur</option>
  <option value="unnao">Unnao</option>
  <option value="varanasi">Varanasi</option>
</select>

              </div>

              <div className="input">
                <label htmlFor="address">Address:</label>
                <input type="text" id="address" name="address" required />
              </div>

              <div className="btn">
                <button className="btn1" type="submit">Submit</button>
              </div>

            </form>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default Donate;
